import { createReducer } from '@reduxjs/toolkit';
import { AssetBreakDownChartStoreState } from '@Types/failureGrade.types';
import { getAssetBreakDownChartAction, getAssetBreakDownChartResolved, getAssetBreakDownChartRejected } from '@Actions';

export const initState: AssetBreakDownChartStoreState = {
	inProcess: false,
	successful: null,
	asset_breakdown: null,
	modelId: null,
	runResultsId: null,
};

export const reducer = createReducer(initState, builder => {
	builder
		.addCase(getAssetBreakDownChartAction, state => {
			state.inProcess = true;
			state.successful = null;
			state.asset_breakdown = null;
			// Clear the keys with the data they describe, so the store never claims a
			// model/run it no longer holds. They are set again only on resolve.
			state.modelId = null;
			state.runResultsId = null;
		})
		.addCase(getAssetBreakDownChartResolved, (state, action) => {
			state.inProcess = false;
			state.successful = true;
			state.asset_breakdown = action.payload.asset_breakdowns;
			state.modelId = action.payload.modelId;
			state.runResultsId = action.payload.runResultsId;
		})
		.addCase(getAssetBreakDownChartRejected, state => {
			state.inProcess = false;
			state.successful = false;
			state.asset_breakdown = null;
			state.modelId = null;
			state.runResultsId = null;
		});
});

export default reducer;
